import { useContext, useState } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import AppContext from '@/common/context/app.context'
import commonServices from '@/common/services/services'

import { merchantStatuses } from '../constants'

const useGoLive = () => {
  const { updateContext } = useContext(AppContext)
  const [showConfirmModal, setShowConfirmModal] = useState(false)

  const { fetchData: goLive, loading } = useFetch(commonServices.goLive, {
    doInitialRequest: false,
  })

  const handleGoLive = async () => {
    await goLive()
    updateContext(context => ({ ...context, status: merchantStatuses.active }))
    setShowConfirmModal(false)
  }

  return {
    showConfirmModal,
    setShowConfirmModal,
    handleGoLive,
    loading,
  }
}

export default useGoLive
